import { render } from "./PhotoClassifyPlatView.vue?vue&type=template&id=7b7f7354&scoped=true"
import script from "./PhotoClassifyPlatView.vue?vue&type=script&lang=js"
export * from "./PhotoClassifyPlatView.vue?vue&type=script&lang=js"

import "./PhotoClassifyPlatView.vue?vue&type=style&index=0&id=7b7f7354&scoped=true&lang=less"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b7f7354"]])

export default __exports__